import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip,
} from "reactstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchModuleProject, fetchModuleProjectClientService,fetchModuleProjectClientServiceClear, changeModuleStatus, fetchModule, saveModule } from "store/actions";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import useButtonAccess from "components/Common/useButtonAccess";

const TimeSheetModule = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);

  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);

  const { 
      module, 
      moduleProject,
      moduleProjectClientService,
      loading,
      success,
      error, 
  } = useSelector((state) => ({
      module : state.TimesheetSetupModuleReducer?.module  ?? [],
      moduleProject : state.TimesheetSetupProjectReducer?.moduleProject  ?? '',
      moduleProjectClientService : state.TimesheetSetupModuleReducer?.moduleProjectClientService  ?? '',           
      loading: state.TimesheetSetupModuleReducer?.loading,
      error: state.TimesheetSetupModuleReducer?.error,
      success: state.TimesheetSetupModuleReducer?.success,
  }));

  useEffect(() => {
      resetFormData();
      const authUserDetails = useAuthUserDetails();
      setAuthDetails(authUserDetails[0])
      const unitId = authUserDetails[0].unit_id     
      const user_id=authUserDetails[0].user_id     
      const formData = new FormData();
      formData.append("unit_id", unitId);    
      formData.append("create_by", user_id);      
      dispatch(fetchModuleProject(formData));      
      dispatch(fetchModule(formData));        
  }, [dispatch]); 

  // useEffect(() => {
  //     if(success){
  //         dispatch(fetchModule(authDetails?.unit_id));          
  //         formik.resetForm();
  //         setIsEdit(false);
  //         setEditId(null);
  //         resetFormData();
  //     }
  // }, [authDetails,success,dispatch]);

  useEffect(() => {
  if (success && authDetails) {
    const formData = new FormData();
    formData.append("unit_id", authDetails.unit_id);
    formData.append("create_by", authDetails.user_id);
    dispatch(fetchModule(formData));  
    setIsEdit(false);
    setEditId(null);
    resetFormData();
  }
}, [success, authDetails]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [projectData,setProjectData] = useState(null);

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname,history);
  }, [location]);
  
  useEffect(() => {
    if (moduleProjectClientService) {
      formik.setFieldValue("client", moduleProjectClientService.client_name);
      formik.setFieldValue("service", moduleProjectClientService.service_name);
    }
  }, [moduleProjectClientService]);
    
  const formik = useFormik({
    initialValues: {
      project: "",      
      client: "",
      service: "",
      module: "",
      description: "",
    },
    validationSchema: Yup.object({
      project: Yup.object().required("Project is required"),
      client: Yup.string().required("Client is required"),
      service: Yup.string().required("Service is required"),
      module: Yup.string().required("Module is required"),
    }),
    onSubmit: (values, { resetForm }) => {      
      const formData = new FormData();
      formData.append("module_id", editId ? editId : 0);
      formData.append("module", values.module);
      formData.append("project_id", values.project.value);
      formData.append("client_id", values.client);
      formData.append("description", values.description);
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(saveModule(formData));  
      resetFormData(); 
    },
  });
  
  const handleEdit = (row) => {
    setIsEdit(true);
    setEditId(row.module_id);
    //fetchClientServiceData(row.project_id);
    formik.setValues({
        project: {value:row.project_id,label:row.project_name},
        module: row.module_name,
        client: row.client_name,
        service: row.service_name,
        description: row.module_description,
    });      
    setProjectData({value:row.project_id,label:row.project_name});         
  };

  const handleToggleStatus = (id,isActive) => {
    Swal.fire({
        title: 'Are you sure?',
        text: `You are about to ${isActive ? 'deactivate' : 'activate'} this module.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        reverseButtons: false,
        dangerMode: true,
    }).then((result) => {
        if (result.isConfirmed) {
            const formData = new FormData();
            formData.append("module_id", id);
            formData.append("unit_id", authDetails?.unit_id);
            dispatch(changeModuleStatus(formData));
        }       
    });
  };

  const CustomSelect = ({
    closeMenuOnScroll = true,
    menuPortalTarget = document.body,
    menuPosition = "fixed",
    menuShouldScrollIntoView = false,
    ...props
  }) => {
    return (
      <Select
        {...props}
        closeMenuOnScroll={closeMenuOnScroll}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        menuShouldScrollIntoView={menuShouldScrollIntoView}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
    );
  };

  const fetchClientServiceData = (id) => {      
    const formData = new FormData();
    formData.append("project_id", id);
    formData.append("unit_id", authDetails?.unit_id);
    formData.append("create_by", authDetails?.user_id);    
    dispatch(fetchModuleProjectClientService(formData));
  };  

  
  const resetFormData = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
    setProjectData(null);
    dispatch(fetchModuleProjectClientServiceClear());
  };
  
  // const resetFormData = () => {
  //   formik.resetForm(); 
  //   setIsEdit(false); 
  //   setEditId(null);
  //   setProjectData(null);
  //   formik.values.client='';   
  //   formik.values.service=''; 
  //   dispatch(fetchModuleProjectClientServiceClear());
  //   formik.setFieldValue("client", '');
  //   formik.setFieldValue("service", '');
  //   formik.resetForm({
  //     values: {
  //       project: "",
  //       module: "",
  //       client: "",
  //       service: "",
  //       description: "",
  //     },
  //   });
  // };

  // const columns = [
  //   {
  //     Header: "Actions",
  //     headerClassName: 'text-center',
  //     className: 'text-center',
  //     Cell: (cellProps) => {
  //       const { b_active, module_id} = cellProps.row.original;
  //       const isActive = b_active === 1; // Status 1 = Active
  //       return (
  //         <div className="text-center">
  //             <Link to="#" className="me-2" style={{ color: isActive ? "green" : "red" }} onClick={() => handleToggleStatus(module_id,isActive)}>
  //               <i className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`} id={`status-tooltip-${cellProps.row.id}`}/>
  //               <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
  //                   {isActive ? "Mark Inactive" : "Mark Active"}
  //               </UncontrolledTooltip>
  //             </Link>
  //             <Link to="#" className="text-success ml-3" onClick={() => handleEdit(cellProps.row.original)}>
  //               <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //               <UncontrolledTooltip placement="top" target="edittooltip">
  //                   Edit
  //               </UncontrolledTooltip>
  //             </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   { Header: "S.No", Cell: ({ row }) => module.length - row.index, className: "serial-no text-center", applyHeaderClass: true, },
  //   { Header: "Client", accessor: "client_name" },
  //   { Header: "Service", accessor: "service_name" },
  //   { Header: "Project", accessor: "project_name" },
  //   { Header: "Module", accessor: "module_name" },
  //   { Header: "Description", accessor: "module_description" },
  //   { Header: "Created By", accessor: "create_by" },
  //   { Header: "Created On", accessor: "create_date" },    
  // ];

  const columns = [
    {
      Header: "Actions",
      headerClassName: "text-center",
      className: "text-center",
      Cell: (cellProps) => {
        const { b_active, module_id } = cellProps.row.original;
        const isActive = b_active === 1;

        return (
          <div className="text-center">

            {/* STATUS TOGGLE */}
            {canDelete && (
              <>
                <span
                  id={`status-${module_id}`}
                  className="me-2"
                  style={{ color: isActive ? "green" : "red", cursor: "pointer" }}
                  onClick={() => handleToggleStatus(module_id, isActive)}
                >
                  <i
                    className={`mdi ${
                      isActive ? "mdi-check-circle" : "mdi-close-circle"
                    } font-size-18`}
                  />
                </span>

                <UncontrolledTooltip
                  placement="top"
                  target={`status-${module_id}`}
                  delay={{ show: 300, hide: 100 }}
                >
                  {isActive ? "Mark Inactive" : "Mark Active"}
                </UncontrolledTooltip>
              </>
            )}

            {/* EDIT */}
            {canEdit && (
              <>
                <span
                  id={`edit-${module_id}`}
                  className="text-success ms-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleEdit(cellProps.row.original)}
                >
                  <i className="bx bxs-edit font-size-18" />
                </span>

                <UncontrolledTooltip
                  placement="top"
                  target={`edit-${module_id}`}
                  delay={{ show: 300, hide: 100 }}
                >
                  Edit
                </UncontrolledTooltip>
              </>
            )}

          </div>
        );
      },
    },

    { Header: "S.No", Cell: ({ row }) => module.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
    { Header: "Client", accessor: "client_name" },
    { Header: "Service", accessor: "service_name" },
    //{ Header: "Project", accessor: "project_name" },
    {
      Header: "Project",
      accessor: "project_name",
      Cell: ({ value }) => (
        <div style={{
          whiteSpace: "nowrap",
          overflow: "auto",
          textOverflow: "clip",
          maxWidth: "600px"
        }} title={value}>
          {value}
        </div>
      ),
      className: "project-single-line"
    },
    { Header: "Module", accessor: "module_name" },
    { Header: "Description", accessor: "module_description" },
    { Header: "Created By", accessor: "create_by" },
    { Header: "Created On", accessor: "create_date" },
  ];

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Timesheet" breadcrumbItem="Module" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="mb-2">
                <Col md={4}>
                  <FormGroup>
                    <Label>Project <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="project"
                      name="project"
                      isMulti={false}
                      options={moduleProject}
                       closeMenuOnScroll={false}
                      menuPosition="absolute"
                      menuPortalTarget={null}
                      value={projectData}
                      onChange={(selectedOption) => {
                          formik.setFieldValue("project", selectedOption);
                          setProjectData(selectedOption);
                          fetchClientServiceData(selectedOption?.value);
                        }
                      }
                      onBlur={() => formik.setFieldTouched("project", true)}
                    /> 
                    {formik.touched.project && formik.errors.project && (
                      <div className="text-danger">{formik.errors.project}</div>
                    )}
                    {
                      /*
                      <Select
                        options={moduleProject}
                        onChange={(selected) => {
                          formik.setFieldValue("project", selected.value);
                          formik.setFieldValue("client", '');
                          formik.setFieldValue("service", '');
                        }}
                        onBlur={() => formik.setFieldTouched("project", true)}
                        value={moduleProject.find((opt) => opt.value === formik.values.project) || null}
                        styles={SelectcustomStyles}
                      />
                      */
                    }                   
                    
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Client</Label>
                    <Input
                      type="text"
                      name="client"
                      value={formik.values.client}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Service</Label>
                    <Input
                      type="text"
                      name="service"
                      value={formik.values.service}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={4}>
                  <FormGroup>
                    <Label>Module <span className="text-danger">*</span></Label>
                    <Input
                      type="text"
                      name="module"
                      maxLength={50}
                      value={formik.values.module}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={formik.errors.module && formik.touched.module ? "is-invalid" : ""}
                    />
                    {formik.touched.module && formik.errors.module && (
                      <div className="text-danger">{formik.errors.module}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Description</Label>
                    <Input
                      type="textarea"
                      name="description"
                      maxLength={200}
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      style={{ maxHeight: "33.1px", minHeight: "33.1px" }}
                    />
                  </FormGroup>
                </Col>
                {/* <Col md={4} className="d-flex align-items-center justify-content-end">
                  <Button type="submit" color="primary" className="btn button-save me-2">
                    <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                  </Button>
                  <Button type="button" className="btn button-cancel" onClick={resetFormData}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col> */}

                 <Col className="d-flex mob-center align-items-center justify-content-end mt-2">                
                    {canCreate && (
                      <Button type="submit" color="primary" className="btn button-save me-2">
                        <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                      </Button>
                    )}
                    <Button type="button" className="btn button-cancel me-2" onClick={resetFormData}>
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
               data={module || []}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TimeSheetModule;
